module.exports = function getResource(label, vars = []) {
    const resources = {
        colorIQHistoryTitle: 'Your Saved Color IQ Scans',
        colorIQHistoryDesc: 'You can get a new Color IQ scan by visiting your nearest Sephora store.',
        latest: 'CURRENT',
        captured: 'Captured',
        gotIt: 'Got It',
        viewAll: 'View All'
    };

    return resources[label];
};
